import React from 'react';
import { Field } from 'react-final-form';
import { FieldSet, Label, LabeledControl, Legend, Paragraph, Radio, Text } from '@zillow/constellation-10';
import type { IdentityCheckQuestion } from '@zg-rentals/ts-id-verification-client';

interface KiqQuestionProps {
  question: IdentityCheckQuestion;
  index: number;
}

export default function KiqQuestion({ question, index }: KiqQuestionProps) {
  const questionChoices = question?.questionChoices?.map((_, idx) => idx + 1);

  return (
    <>
      <Text textStyle="body-bold" css={{ marginBlock: 'default' }}>
        Question #{index + 1}
      </Text>
      <FieldSet
        legend={
          <Legend>
            <Paragraph css={{ marginBottom: 'default' }}>{question.questionText}</Paragraph>
          </Legend>
        }
        css={{ '&:not(:last-child)': { marginBottom: 'loose' } }}
      >
        {question.questionChoices.map((questionChoice, questionChoiceIndex) => (
          <Field
            key={questionChoice}
            // Answers to Experian use 1-based indexing
            value={`${questionChoiceIndex + 1}`}
            type="radio"
            name={`question-${index}`}
            render={({ input }) => (
              <LabeledControl label={<Label>{questionChoice}</Label>} control={<Radio {...input} />} />
            )}
            validate={(choice) => {
              return questionChoices.includes(Number(choice)) ? undefined : 'Invalid answer.';
            }}
          />
        ))}
      </FieldSet>
    </>
  );
}
